module.exports = __webpack_public_path__ + "img/pizza-dancer.a33ce4c8.webp";